var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile"},[(_vm.getToggled)?_c('div',{staticClass:"mobile-item mobile--modal"}):_vm._e(),_c('div',{staticClass:"mobile-item mobile--nav",class:_vm.menuClass},[_c('nav',[_c('NavList')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }